export default __webpack_public_path__ + "static/media/hug.0b35abaf.png";